import { combineReducers } from 'redux';

import auth from './authReducer';
import autocomplete from './autocompleteReducer';
import clips from './clipsReducer';
import player from './playerReducer';
import search from './searchReducer';
import tracks from './tracksReducer';
import transcripts from './transcriptsReducer';
import uploads from './uploadsReducer';

export const rootReducer = combineReducers({
  auth,
  autocomplete,
  clips,
  player,
  search,
  tracks,
  transcripts,
  uploads,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.ts